import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatSpecification } from '../../../utils/commonUtils';

export default function ViewProductModal({ product, isOpen, onClose, isFBZ }) {
  const { t } = useTranslation('Products');
  return (
    <div
      className="modal fade"
      id="product-detail"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="staticBackdropLabel">
              {t('VIEWPRODUCTDETAILS')}
            </h1>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <div className="product-inner">
              <ul>
                <li>
                  <p>{t('PRODUCTCODE')}</p>
                  <span>-</span>
                  <h3>{product.code}</h3>
                </li>
                <li>
                  <p>{t('CATEGORY')}</p>
                  <span>-</span>
                  <h3>{product?.category?.name || ''}</h3>
                </li>
                <li>
                  <p>{t('PROCESSCATEGORY')}</p>
                  <span>-</span>
                  <h3>{product?.process_category?.name || ''}</h3>
                </li>
                <li>
                  <p>{t('PRODUCTNAME')}</p>
                  <span>-</span>
                  <h3>{product.name}</h3>
                </li>
                <li>
                  <p>{t('ORIGIN')}</p>
                  <span>-</span>
                  <h3>{product.origin?.name}</h3>
                </li>
                <li>
                  <p>{t('SPECIFICATION')}</p>
                  <span>-</span>
                  <h3>{formatSpecification(product)}</h3>
                </li>
                {!isFBZ && (
                  <li>
                    <p>{t('NETWEIGHT')}</p>
                    <span>-</span>
                    <h3>{product.net_weight}</h3>
                  </li>
                )}
                <li>
                  <p>{t('PROCESSLOCATION')}</p>
                  <span>-</span>
                  <h3>{product?.process_location?.name || ''}</h3>
                </li>
                {isFBZ && (
                  <>
                    <li>
                      <p>{t('RELATEDPRODUCTS')}</p>
                      <span>-</span>
                      <h3>
                        {product?.related_product?.code &&
                        product?.related_product?.name
                          ? `${product.related_product.code} | ${product.related_product.name}`
                          : product?.related_product?.code ||
                            product?.related_product?.name ||
                            ''}
                      </h3>
                    </li>
                    <li>
                      <p>{t('CONVERSIONRATE')}</p>
                      <span>-</span>
                      <h3>{product?.conversion_rate || ''}</h3>
                    </li>
                  </>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
